
import { useEffect, useState } from 'react';

type ThemeMode = 'dark';

export function useThemeMode() {
  const [theme] = useState<ThemeMode>('dark');
  const [systemTheme] = useState<'dark'>('dark');

  // Apply dark theme
  useEffect(() => {
    document.documentElement.classList.remove('light', 'dark');
    document.documentElement.classList.add('dark');
  }, []);

  const toggleTheme = () => {
    // No-op since we only support dark mode
  };

  const setTheme = () => {
    // No-op since we only support dark mode
  };

  return {
    theme,
    systemTheme,
    resolvedTheme: 'dark' as const,
    setTheme,
    toggleTheme,
    isDark: true
  };
}
